(function() {
  'use strict';

  function init() {
    initMobileMenu();
    initProductThumbs();
    initQuantitySelector();
    initVariantSelect();
    initAddToCart();
    initNewsletterForm();
  }

  function initMobileMenu() {
    var btn = document.querySelector('[data-mobile-menu]');
    var drawer = document.getElementById('shopify-section-header-drawer');
    var closes = document.querySelectorAll('[data-close-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function() { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
    closes.forEach(function(el) { el.addEventListener('click', function() { drawer.hidden = true; document.body.style.overflow = ''; }); });
  }

  function initProductThumbs() {
    var thumbs = document.querySelectorAll('.product-thumb');
    var main = document.querySelector('.product-main-img img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        thumbs.forEach(function(x) { x.classList.remove('active'); });
        t.classList.add('active');
        var newSrc = t.getAttribute('data-full-src');
        if (newSrc) main.src = newSrc;
      });
    });
  }

  function initQuantitySelector() {
    document.querySelectorAll('.qty-selector').forEach(function(sel) {
      var input = sel.querySelector('.qty-input');
      var btns = sel.querySelectorAll('.qty-btn');
      btns.forEach(function(b) {
        b.addEventListener('click', function() {
          var step = parseInt(b.getAttribute('data-step'), 10) || 1;
          var current = parseInt(input.value, 10) || 1;
          var next = Math.max(1, current + step);
          input.value = next;
        });
      });
    });
  }

  function initVariantSelect() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var inputs = form.querySelectorAll('input[name^="option"]');
    inputs.forEach(function(i) {
      i.addEventListener('change', function() {
        var selected = [];
        form.querySelectorAll('input[name^="option"]:checked').forEach(function(x) { selected.push(x.value); });
        var variants = window.productVariants || [];
        var match = variants.find(function(v) {
          return JSON.stringify(v.options) === JSON.stringify(selected);
        });
        var idInput = form.querySelector('input[name="id"]');
        if (match && idInput) {
          idInput.value = match.id;
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        }
      });
    });
  }

  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    });
  }

  function initNewsletterForm() {
    var forms = document.querySelectorAll('.newsletter-form');
    forms.forEach(function(f) {
      f.addEventListener('submit', function(e) {
        var btn = f.querySelector('button');
        if (btn) btn.textContent = 'Subscribing...';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
